import { useState } from "react";
import { Outlet, useNavigate, Link } from "react-router";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from "@mui/material";
import Logo from "components/Logo";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useAuthenticatedUser } from "../AuthProvider";
import { CompanyName } from "components/CompanyName";
import { auth } from "../firebase";
import { getJaDisplayName } from "components/userUtil";
import { useUserPermissions } from "components/useUserPermissions";

export default function LoginLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const user = useAuthenticatedUser();

  const { isShowInfoChangeReq } = useUserPermissions();

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogout = async () => {
    if (!confirm("ログアウトしますか？")) {
      return;
    }
    try {
      await auth.signOut();
      navigate("/login");
    } catch (error: unknown) {
      console.error("ログアウトエラー:", error);
      alert(
        error instanceof Error
          ? error.message
          : "ログアウトに失敗しました。再度お試しください。",
      );
    }
  };

  return (
    <>
      {/* Header */}
      <AppBar position="static">
        <Toolbar>
          <Box sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
          }}>
            <Logo />
          </Box>
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Drawer Menu */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer}>
        <Box sx={{ width: 250 }} role="presentation">
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            <IconButton onClick={toggleDrawer} aria-label="close drawer">
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            <ListItem>
              <Box sx={{ width: "100%" }}>
                <Typography variant="caption" color="text.secondary">
                  {getJaDisplayName("companyName")}
                </Typography>
                <ListItemText primary={<CompanyName />} />
              </Box>
            </ListItem>
            <ListItem>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="caption" color="text.secondary">
                    メールアドレス
                  </Typography>
                </Box>
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        wordBreak: "break-all",
                        overflowWrap: "break-word",
                      }}
                    >
                      {user.email}
                    </Typography>
                  }
                />
              </Box>
            </ListItem>
            <Divider sx={{ mt: 3, mb: 3 }} />
            {false && isShowInfoChangeReq &&
              <ListItem>
                <Button
                  component={Link}
                  to="/changereq"
                  variant="contained"
                  fullWidth
                  onClick={toggleDrawer}
                >
                  会員情報変更
                </Button>
              </ListItem>
            }
            <ListItem>
              <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={handleLogout}
              >
                ログアウト
              </Button>
            </ListItem>
            <Divider sx={{ mt: 3, mb: 3 }} />
            <ListItem>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                href="https://nishinihonfactor-plus.jp"
                target="_blank"
                rel="noopener noreferrer"
                onClick={toggleDrawer}
              >
                フロントページへ戻る
              </Button>
            </ListItem>
          </List>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box component="main">
        <Outlet />
      </Box>
    </>
  );
}
